import { gql } from '@apollo/client';
import { ISvgOrImage, SvgFragment } from './svg';
import { MemberDayTagName } from '@/components/constants/memberdayTagName';

export interface ILibraryTenantAttributeFilters {
  giftCardAvailable: boolean;
  giftCardLabel: string;
  giftCardIcon?: ISvgOrImage;
  giftCardChecked: boolean;

  loyaltyCardAvailable: boolean;
  loyaltyCardLabel: string;
  loyaltyCardIcon?: ISvgOrImage;
  loyaltyCardChecked: boolean;

  offerPageAvailable?: boolean;
  offerPageLabel: string;

  memberDayCardAvailable?: boolean;
  memberDayCardLabel: string;
}

export const defaultAttributeFilters: ILibraryTenantAttributeFilters = {
  giftCardAvailable: false,
  giftCardLabel: 'Gift Card',
  giftCardChecked: false,
  loyaltyCardAvailable: false,
  loyaltyCardLabel: 'Loyalty Card',
  loyaltyCardChecked: false,
  offerPageLabel: '',
  memberDayCardAvailable: false,
  memberDayCardLabel: MemberDayTagName,
};

export const LibraryTenantAttributeFiltersFragment = gql`
  ${SvgFragment}
  fragment LibraryTenantAttributeFilters on LibraryTenantAttributeFilters {
    sys {
      id
    }
    internalName
    giftCardAvailable
    giftCardLabel
    giftCardIcon {
      description
      ... on Asset {
        ...Svg
      }
    }
    loyaltyCardAvailable
    loyaltyCardLabel
    loyaltyCardIcon {
      description
      ... on Asset {
        ...Svg
      }
    }
  }
`;
